import React from 'react';
import {Link} from "react-router-dom";

function Language(props){

  const languageStyle={
    backgroundColor:'#012782',
    color:'white',
    margin:'0px',
    textDecoration: 'none',
  }

  const linkStyle ={
    float: 'left',
    margin: '0px',
    textDecoration: 'none',
    color: 'white',
    fontSize: '1.5vh',
  }


  return(
    <div className="container-fluid" style={languageStyle}>
      <div className="row justify-content-end">
        <div className="col-2 col-md-1"><Link to='' style={linkStyle} >한국어</Link></div>
        <div className="col-2 col-md-1"><Link to='' style={linkStyle} >English</Link></div>
        <div className="col-2 col-md-1"><Link to='' style={linkStyle} >Log in</Link></div>
      </div>
    </div>
  )
}

export default Language